export default __webpack_public_path__ + "static/media/weightlossregime@3x.7a60ceae.jpg";